export const CONTAINER_WIDTH = `1200px`
export const MAIN_COLOR = '#262D7A'
export const SECONDARY_COLOR = '#E8BF6C'
export const BACKGROUND_COLOR = '#FAF1EA'
export const BACKGROUND_COLOR2 = '#E2D6CC'
export const ICON_COLOR = '#BDA592'
export const ERROR_COLOR = '#cc3429'
